// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../../node_modules/react-slideshow-image/dist/styles.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slide-container .react-slideshow-container .default-nav {
    background: var(--basic-gray-color);
    margin-left: -15px;
    margin-right: -15px;
    width: 35px;
    height: 35px;
}

.slide-container .react-slideshow-container .default-nav svg {
    fill: var(--white-color);
    width: 12px;
    height: 12px;

}

.slide-container .react-slideshow-container .default-nav:hover, .react-slideshow-container .default-nav:focus {
    background: var(--basic-gray-color);
    outline: 0;
}

.slide-container .react-slideshow-fadezoom-wrapper img {
    border-radius: 16px;
}

.slide-container ul.indicators {
    border-radius: 20px;
    background: var(--white-color);
    margin-top: 10px;
    width: fit-content;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    padding-inline-start: 0;
    padding: 6px;
}

.slide-container ul.indicators li {
    width: 10px;
    height: 10px;
    margin: 0 7px;
}

.slide-container ul.indicators li:first-of-type {
    margin: 0 4px 0 0;
}

.slide-container ul.indicators li:last-of-type {
    margin: 0 0 0 4px;
}

.slide-container .react-slideshow-container+ul.indicators .each-slideshow-indicator {
    opacity: 1;
    background: none;
}

.slide-container .react-slideshow-container+ul.indicators .each-slideshow-indicator:before {
    width: 10px;
    height: 10px;
    background: var(--new-gray-background-color);
    opacity: 1;
}

.slide-container .react-slideshow-container+ul.indicators .each-slideshow-indicator:hover, .react-slideshow-container+ul.indicators .each-slideshow-indicator.active::before {
    background: var(--new-green-color);
    outline: 0;
    opacity: 1;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .slide-container {
        padding: 8px;
    }

    .slide-container ul.indicators {
        margin-top: 6px;
        margin-block-start: 0;
        margin-block-end: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/shared/components/slideshow/SlideshowComponent.styles.css"],"names":[],"mappings":"AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,YAAY;;AAEhB;;AAEA;IACI,mCAAmC;IACnC,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,4CAA4C;IAC5C,UAAU;AACd;;AAEA;IACI,kCAAkC;IAClC,UAAU;IACV,UAAU;AACd;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,qBAAqB;QACrB,mBAAmB;IACvB;AACJ","sourcesContent":["@import \"react-slideshow-image/dist/styles.css\";\n\n.slide-container .react-slideshow-container .default-nav {\n    background: var(--basic-gray-color);\n    margin-left: -15px;\n    margin-right: -15px;\n    width: 35px;\n    height: 35px;\n}\n\n.slide-container .react-slideshow-container .default-nav svg {\n    fill: var(--white-color);\n    width: 12px;\n    height: 12px;\n\n}\n\n.slide-container .react-slideshow-container .default-nav:hover, .react-slideshow-container .default-nav:focus {\n    background: var(--basic-gray-color);\n    outline: 0;\n}\n\n.slide-container .react-slideshow-fadezoom-wrapper img {\n    border-radius: 16px;\n}\n\n.slide-container ul.indicators {\n    border-radius: 20px;\n    background: var(--white-color);\n    margin-top: 10px;\n    width: fit-content;\n    text-align: center;\n    margin-left: auto;\n    margin-right: auto;\n    padding-inline-start: 0;\n    padding: 6px;\n}\n\n.slide-container ul.indicators li {\n    width: 10px;\n    height: 10px;\n    margin: 0 7px;\n}\n\n.slide-container ul.indicators li:first-of-type {\n    margin: 0 4px 0 0;\n}\n\n.slide-container ul.indicators li:last-of-type {\n    margin: 0 0 0 4px;\n}\n\n.slide-container .react-slideshow-container+ul.indicators .each-slideshow-indicator {\n    opacity: 1;\n    background: none;\n}\n\n.slide-container .react-slideshow-container+ul.indicators .each-slideshow-indicator:before {\n    width: 10px;\n    height: 10px;\n    background: var(--new-gray-background-color);\n    opacity: 1;\n}\n\n.slide-container .react-slideshow-container+ul.indicators .each-slideshow-indicator:hover, .react-slideshow-container+ul.indicators .each-slideshow-indicator.active::before {\n    background: var(--new-green-color);\n    outline: 0;\n    opacity: 1;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .slide-container {\n        padding: 8px;\n    }\n\n    .slide-container ul.indicators {\n        margin-top: 6px;\n        margin-block-start: 0;\n        margin-block-end: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
